import { useEffect, useState } from 'react';
import { Box, Checkbox, List, ListItem, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { handleAmount } from '../../../../shared/extra';
import WalletPaymentConfirm from '../../../../components/alertPopup/WalletPaymentConfirm';
import { calculatePayment } from '../customPaymentHook';

function PayFromWallet({ walletPayment, setWalletPayment }) {
  const [netPay, setNetPay] = useState(0);
  const [walletPayConfirm, setWalletPayConfirm] = useState(false);

  let userProfile = useSelector((state) => state.UserProfile.allData?.data);
  const DENOMINATION_STORE_DATA = useSelector((state) => state.Denominations?.allData);
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const balance = useSelector((state) => state.UserBalance.allData);

  useEffect(() => {
    if (DENOMINATION_STORE_DATA?.length > 0) {
      const calculationResult = calculatePayment(
        DENOMINATION_STORE_DATA,
        PRODUCTDETAILS.discount,
        PRODUCTDETAILS.isCashbackProduct
      );
      setNetPay(calculationResult.netPaymentAmt);
    } else {
      setNetPay(0);
    }
  }, [DENOMINATION_STORE_DATA]);

  const handleWalletPayConfirmOpen = () => {
    setWalletPayConfirm(true);
  };

  const handleWalletPayConfirmClose = () => {
    setWalletPayConfirm(false);
  };

  return (
    <>
      <Box sx={{ mt: { xs: 0, lg: 2 } }}>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            pr: 0.5,
            my: {
              xs: 1,
              lg: 0.5,
            },
            height: 24,
          }}
        >
          <Typography
            variant="body1"
            gutterBottom
            sx={{
              color: {
                xs: 'primary.main',
                sm: 'textPrimary.main',
              },
              fontSize: {
                xs: '1.2rem',
                sm: '13.5px',
                lg: '15px',
              },
              fontWeight: { xs: 700, sm: 700, lg: 700 },
              textAlign: { xs: 'center', lg: 'left' },
              mb: { xs: 1, lg: 0 },
              borderBottom: { xs: 1, lg: 0 },
              mt: { xs: 1, sm: 1, lg: 0 },
            }}
          >
            Pay with Wallet
          </Typography>
        </Stack>

        <Box sx={{ borderRadius: 2, minHeight: '30px', p: 0, backgroundColor: 'secondary.light' }}>
          <List sx={{ py: 0 }}>
            <ListItem sx={{ justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: 'textPrimary.main',
                    fontWeight: 500,
                    fontSize: {
                      xs: '.9rem',
                      sm: '14px',
                    },
                  }}
                >
                  Available Balance :
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: 'textPrimary.main',
                    fontWeight: 600,
                    fontSize: {
                      xs: '1rem',
                      sm: '16px',
                    },
                    py: 0,
                    ml: 2,
                  }}
                >
                  &#8377;{balance >= 1 ? handleAmount(balance) : '0.00'}
                </Typography>
              </Box>

              <Checkbox
                inputProps={{ 'aria-label': 'Pay from wallet' }}
                checked={walletPayment?.isWalletPayment}
                onClick={handleWalletPayConfirmOpen}
                disabled={!netPay || userProfile?.['balance'] <= 1}
              />
            </ListItem>
          </List>
        </Box>
      </Box>

      <WalletPaymentConfirm
        open={walletPayConfirm}
        walletPayConfirmTitle={'Pay from Your Wallet'}
        walletPayConfirmContent={walletPaymentConfirmation(userProfile, netPay)}
        handleWalletPayConfirmClose={handleWalletPayConfirmClose}
        setWalletPayment={setWalletPayment}
      />
    </>
  );

  function walletPaymentConfirmation(userProfile, totalPayout) {
    return (
      <Typography
        variant="subtitle1"
        sx={{
          color: 'dark.main2',
          fontSize: '18px',
          textTransform: 'capitalize',
          fontWeight: { xs: 700, sm: 700, lg: 700 },
          textAlign: 'center',
        }}
      >
        Are you sure you want to deduct
        <Typography
          component="span"
          sx={{ color: 'dark.main', fontWeight: 500, fontSize: '18px', px: 1 }}
        >
          ₹{totalPayout > userProfile?.['balance'] ? userProfile?.['balance'] : totalPayout}
        </Typography>
        amount from your wallet ?
      </Typography>
    );
  }
}

export default PayFromWallet;
